import { RatingService } from 'app/shared/services/rating/rating.service';
import { OpenDialogRatingsComponent } from './../../dialog/open-dialog-ratings/open-dialog-ratings.component';
import { OpenDialogConfirmComponent } from './../../dialog/open-dialog-confirm/open-dialog-confirm.component';
import { SessionByDate, SessionStatus } from './../../../shared/models/class/session/session';
import { SessionService } from './../../../shared/services/session/session.service';
import { UiService } from './../../../shared/services/ui/ui.service';
import { Component, OnInit } from '@angular/core';
import { DatatableBaseComponent } from 'app/shared/components/datatable-base.component';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';
import { ActivatedRoute } from '@angular/router';
import { InfosUser } from 'app/shared/models/class/auth/infosUser';
import { PageEvent } from '@angular/material/paginator';
import { ThemePalette } from '@angular/material/core';
import { MatTableDataSource } from '@angular/material/table';
import * as moment from 'moment';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-admin-sessions',
  templateUrl: './admin-sessions.component.html',
  styleUrls: ['./admin-sessions.component.scss']
})
export class AdminSessionsComponent extends DatatableBaseComponent  implements OnInit {
  sessions: SessionByDate[] = [];
  sessionStatus: SessionStatus[] = [];
  clubCode: any;
  title: string;

  userConnected: InfosUser;

  dataSource: MatTableDataSource<SessionByDate>;

  dateForm: UntypedFormGroup;
  searchForm: UntypedFormGroup;

  valueInput: string;

  length: number;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 25, 50];
  pageEvent: PageEvent;
  color: ThemePalette = 'primary';

  displayedColumns = ['offerName','dateLib', 'sessionStartDate', 'sessionEndDate', 'bookedSessionTrainees', 'rating', 'status', 'actions'];

  constructor(
    protected uiSrv: UiService,
    private sessionsSrv: SessionService,
    private formBuilder: UntypedFormBuilder,
    private faIconService: FaiconService,
    private authService: AuthService,
    private tooltipSrv: TooltipService,
    private route: ActivatedRoute,
    private dialog: MatDialog
  ) {
    super(uiSrv)
  }

  ngOnInit(): void {
    this.userConnected = this.authService.getDecodedToken();

    this.initComponent();
  }

  async initComponent() {
    this.clubCode = await this.route.snapshot.queryParams.clubCode && this.userConnected.role === 'admin' ?
      this.route.snapshot.queryParams.clubCode : this.userConnected.club_code;

    const title = {
      admin: `Liste des sessions du club : ${this.clubCode}`,
      club: `Liste des sessions de mon club`
    };

    this.title = title[this.userConnected.role];

    this.initSub();

    this.initForm();

    this.onSubmit();
  }

  initSub() {
    this.addSubscription(
      this.sessionsSrv.sessionsListChanged.subscribe(sessionsFromSrv => {
        this.sessions = sessionsFromSrv;
        this.initTable();
      })
    )

    this.addSubscription(
      this.sessionsSrv.getSessionStatus().subscribe(status => {
        this.sessionStatus = status;
      })
    )

    // this.addSubscription(
    //   this.sessionsSrv.getSessionsByClub(this.clubCode).subscribe((sessionsFromSrv => {
    //     this.sessions = sessionsFromSrv;
    //   }))
    // );
  }

  initForm(): void{
    let dateNow = new Date();
    let dateTo = new Date(new Date().setMonth(dateNow.getMonth()+2));

    this.dateForm = this.formBuilder.group({
      startDate: [dateNow, Validators.required],
      endDate: [dateTo, Validators.required]
    })

    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
  }

  private initTable(): void {
    this.dataSource = new MatTableDataSource(this.sessions);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.length = this.sessions.length;
    this.isLoading = false;
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  getTooltip(value: string): string {
    return this.tooltipSrv.getTooltip(value);
  }

  onSubmit(): void{
    const formValues = this.dateForm.value;
    const dateNowFormated = moment(formValues.startDate).startOf('day').utc().format().toString();
    const dateToFormated = moment(formValues.endDate).endOf('day').utc().format().toString();

    this.sessionsSrv.getSessionsByClub(this.clubCode, dateNowFormated, dateToFormated).subscribe(() => {
      this.uiSrv.showSnackbar('Recherche effectuée', false)
    })

    this.isLoading = true;
  }

  changeStatus(action: number, session: SessionByDate): void {
    let message = '';

    if (action === 2) {
      message += 'Êtes-vous certain de rendre cette session planifiée ?';
    } else if (action === 3) {
      message += 'Êtes-vous certain de rendre cette session terminée ?';
    } else if (action === 9) {
      message += 'Êtes-vous certain de rendre cette session évaluée ?';
    }
    const dialogRef = this.dialog.open(OpenDialogConfirmComponent, {
      data: { text: message },
      width: '30%'
    });

    dialogRef.afterClosed().subscribe({
      next: res => {
        if (res) {
           this.sessionsSrv.changeStatus(session.sessionKey, action).subscribe(() => {
             this.uiSrv.showSnackbar('Changement de statut effectué');
             this.sessionStatus.map(status => {
              if (status.bookedSessionStatusKey === action) {
                session.status = status.name;
              }
             })
           })
          }
      }
    });
  }

  applyFilter(filterValue: string): void {
    this.valueInput = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  resetSearch(): void {
    this.searchForm.get('keyword').setValue('');
    this.valueInput = '';
    this.applyFilter(this.valueInput);
  }

  openDialogRatings(element) {
    const dialogRef = this.dialog.open(OpenDialogRatingsComponent, {
      data: { session: element },
      width: '30%',
      maxHeight: '80%',
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe({
      next: res => {

      }
    });
  }

}
